function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientBillEditApi, clientBillSaveApi, clientConfigListApi, selectContractListApi, clientFollowEditApi, clientFollowSaveApi, clientRemindEditApi, clientRemindSaveApi, enterprisePayTypeApi } from '@/api/enterprise';
import { getDictDataListApi } from '@/api/form';
import { getToken } from '@/utils/auth';
import SettingMer from '@/libs/settingMer';
import { uploader } from '@/utils/uploadCloud';
export default {
  name: 'ContractDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var checkAmount = function checkAmount(rule, value, callback) {
      if (_this.rules.radio == 1 && !value) {
        return callback(new Error(_this.$t('customer.placeholder33')));
      } else if (_this.rules.radio == 2 && !value) {
        return callback(new Error(_this.$t('customer.placeholder35')));
      } else if (_this.config.type === 3 && !value) {
        return callback(new Error(_this.$t('customer.placeholder37')));
      } else if (_this.config.type === 4 && !value) {
        return callback(new Error(_this.$t('customer.placeholder35')));
      } else {
        callback();
      }
    };
    var checkDateTime = function checkDateTime(rule, value, callback) {
      if (_this.rules.radio == 1 && !value) {
        if (_this.config.type == 3) {
          return callback(new Error(_this.$t('customer.placeholder38')));
        } else {
          return callback(new Error(_this.$t('customer.placeholder34')));
        }
      } else if (_this.rules.radio == 2 && !value) {
        return callback(new Error(_this.$t('customer.placeholder36')));
      } else if (_this.config.type === 4 && !value) {
        return callback(new Error(_this.$t('customer.placeholder39')));
      } else if (_this.config.type === 5 && !value) {
        return callback(new Error(_this.$t('customer.placeholder41')));
      } else {
        callback();
      }
    };
    var checkType = function checkType(rule, value, callback) {
      if ((_this.rules.radio == 2 || _this.config.type === 4) && !value) {
        return callback(new Error(_this.$t('customer.placeholder31')));
      } else {
        callback();
      }
    };
    var checkRemark = function checkRemark(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this.$t('customer.placeholder40')));
      } else {
        callback();
      }
    };
    var checkContent = function checkContent(rule, value, callback) {
      if (_this.config.type === 5 && !value) {
        return callback(new Error(_this.$t('customer.placeholder40')));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      remind_id: '',
      rules: {
        cid: '',
        amount: undefined,
        dateTime: '',
        remarks: '',
        type: '',
        rate: undefined,
        content: '',
        attach_ids: '',
        endDate: '',
        type_id: '',
        radio: 1
      },
      val: '',
      imageUrl: '',
      uploadSize: 2,
      uploadData: {},
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      expireTimeOption: {
        disabledDate: function disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7;
        }
      },
      rule: {
        cid: [{
          required: true,
          message: '请选择合同',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          validator: checkAmount,
          trigger: 'blur'
        }],
        dateTime: [{
          required: true,
          validator: checkDateTime,
          trigger: 'change'
        }],
        type: [{
          required: true,
          validator: checkType,
          trigger: 'change'
        }],
        type_id: {
          required: true,
          message: '请选择支付方式',
          trigger: 'change'
        },
        // 支付方式
        remarks: [{
          required: true,
          validator: checkRemark,
          trigger: 'blur'
        }],
        content: [{
          required: true,
          validator: checkContent,
          trigger: 'blur'
        }],
        radio: [{
          required: true,
          message: '请选择业务类型',
          trigger: 'change'
        }],
        endDate: [{
          required: true,
          message: '请选择提醒时间',
          trigger: 'change'
        }]
      },
      title01: '回款金额(元)',
      title02: '',
      placeholder01: '请输入回款金额',
      placeholder02: this.$t('customer.placeholder33'),
      labelWidth: 120,
      payText: '',
      sourceOptions: [],
      paymentOptions: [],
      typeOptions: [{
        value: 0,
        label: this.$t('access.day')
      }, {
        value: 1,
        label: this.$t('user.work.week')
      }, {
        value: 2,
        label: this.$t('user.work.month')
      }, {
        value: 3,
        label: this.$t('calendar.year')
      }],
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '前天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
            picker.$emit('pick', date);
          }
        }]
      },
      contractData: []
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        if (nVal.cid) {
          this.rules.cid = nVal.cid;
        }
        if (nVal.type == 1) {
          if (nVal.data.types == 0) {
            this.rules.radio = 1;
          } else if (nVal.data.types == 1) {
            this.rules.radio = 2;
            this.title01 = '续费金额(元)';
            this.title02 = '续费结束日期';
            this.placeholder02 = this.$t('customer.placeholder36');
          } else {
            this.rules.radio = 1;
            this.title01 = '回款金额(元)';
          }
          if (nVal.data.renew) {
            this.rules.type = nVal.data.renew.id;
          } else {
            this.rules.type = nVal.data.cate_id;
          }
          this.rules.amount = nVal.data.num || undefined;
          this.remind_id = nVal.data.id || '';
        }
        if (nVal.type == 2) {
          if (nVal.data.types == 0) {
            this.rules.radio = 1;
          } else {
            this.rules.radio = 2;
          }
          if (nVal.data.renew) {
            this.rules.type = nVal.data.renew.id;
          }
          if (JSON.stringify(nVal.data.attachs) !== '[]') {
            this.imageUrl = nVal.data.attachs[0].src || '';
          }
          this.rules.amount = nVal.data.num;
          this.rules.type_id = nVal.data.type_id;
          this.rules.remarks = nVal.data.mark;
          this.rules.dateTime = nVal.data.date;
          if (nVal.data.end_date == '0000-00-00') {
            this.rules.endDate = '';
          } else {
            this.rules.endDate = nVal.data.end_date;
          }
          this.title01 = '续费金额(元)';
          this.title02 = '续费结束日期';
          this.placeholder01 = this.$t('customer.placeholder35');
          this.placeholder02 = this.$t('customer.placeholder36');
        }
        if (nVal.type == 3) {
          this.rules.amount = nVal.data.num;
          if (nVal.data.renew) {
            this.rules.type = nVal.data.renew.id;
          }
          if (nVal.data.types == 1) {
            this.rules.radio = 2;
            this.title02 = '续费提醒时间'; // 回款提醒日期
            this.placeholder02 = '请选择续费提醒时间';
            this.rules.endDate = nVal.data.time;
            this.title01 = '续费金额(元)';
            this.placeholder01 = '请输入续费金额';
          } else {
            this.rules.radio = 1;
            this.title02 = '回款提醒日期'; // 回款提醒日期
            this.placeholder02 = this.$t('customer.placeholder38');
            this.rules.endDate = nVal.data.time;
            this.title01 = this.$t('customer.collectionamount01'); // 预计回款金额
            this.placeholder01 = this.$t('customer.placeholder37'); //
          }
          this.rules.remarks = nVal.data.mark;
        }
      },
      deep: true
    },
    lang: function lang() {
      this.setOptions();
    }
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    },
    fileUrl: function fileUrl() {
      return SettingMer.https + "/system/attach/upload";
    },
    mandatory: function mandatory() {
      if (this.config.type == 3) {
        return 'endDate';
      } else {
        return '';
      }
    },
    paymentJudgment: function paymentJudgment() {
      var arrPay = [];
      this.paymentOptions.map(function (item) {
        arrPay.push(item.id);
      });
      return arrPay.indexOf(this.config.data.type_id);
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.typeOptions = [{
        value: 0,
        label: this.$t('access.day')
      }, {
        value: 1,
        label: this.$t('user.work.week')
      }, {
        value: 2,
        label: this.$t('user.work.month')
      }, {
        value: 3,
        label: this.$t('calendar.year')
      }];
    },
    getTableData: function getTableData() {
      var _this2 = this;
      selectContractListApi({
        data: [this.config.eid]
      }).then(function (res) {
        _this2.contractData = res.data;
        if (_this2.contractData.length > 0) {
          if (_this2.config.type == 1 && _this2.config.formType) {
            _this2.rules.cid = _this2.contractData[0].id;
          }
        }
      });
    },
    radioChange: function radioChange(e) {
      this.rules.radio = e;
      if (e == 1) {
        if (this.config.type == 3) {
          this.title01 = '预计回款金额';
          this.title02 = '回款提醒日期';
        } else {
          this.title01 = '回款金额(元)';
          this.title02 = '回款提醒日期';
        }
        this.placeholder02 = this.$t('customer.placeholder34');
        this.placeholder01 = this.$t('customer.placeholder33');
      } else if (e == 2) {
        if (this.config.type == 3) {
          this.title01 = this.$t('customer.renewalamount');
          this.placeholder01 = this.$t('customer.placeholder35');
          this.title02 = this.$t('customer.renewaldate01');
          this.placeholder02 = this.$t('customer.placeholder39');
        } else {
          this.title01 = '续费金额(元)';
          this.title02 = '续费结束日期';
          this.placeholder01 = this.$t('customer.placeholder35');
          this.placeholder02 = this.$t('customer.placeholder36');
        }
      }
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this3 = this;
      this.percentShow = true;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: 'bill',
        relation_id: 0,
        eid: 0
      };
      uploader(file, 1, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this3.imageUrl = res.url;
          _this3.rules.attach_ids = res.attach_id;
        }
      }).catch(function (err) {});
    },
    // 获取当前时间
    getTime: function getTime() {
      this.rules.dateTime = this.$moment().format('YYYY-MM-DD HH:mm:ss');
    },
    // 列表
    getClientList: function getClientList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var obj, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              obj = {
                types: 'client_renew',
                level: 1
              };
              _context.next = 3;
              return getDictDataListApi(obj);
            case 3:
              result = _context.sent;
              _this4.sourceOptions = result.data.list === undefined ? [] : result.data.list;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
      this.getTime();
      this.getPaymentMethod();
      // this.getClientList()
      if (this.config.type == 1 && this.config.formType) {
        this.getTableData();
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.imageUrl = '';
      this.rules.endDate = '';
      this.rules.type = '', this.$refs.form.resetFields();
      if (this.config.edit === 2) {
        this.reset();
      }
      this.reset();
    },
    // 提交回款/续费/付款提醒
    handleConfirm: function handleConfirm() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 添加回款
          var data = {};
          if (_this5.rules.radio == 1 && _this5.config.type !== 3) {
            data = {
              cid: _this5.config.cid,
              eid: _this5.config.eid,
              types: 0,
              cate_id: 0,
              num: _this5.rules.amount,
              mark: _this5.rules.remarks,
              date: _this5.$moment(_this5.rules.dateTime).format('YYYY-MM-DD HH:mm:ss'),
              end_date: _this5.rules.endDate ? _this5.$moment(_this5.rules.endDate).format('YYYY-MM-DD ') : '',
              type_id: _this5.rules.type_id,
              attach_ids: _this5.rules.attach_ids,
              bill_types: 1,
              remind_id: _this5.remind_id ? _this5.remind_id : _this5.config.cid
            };
            if (_this5.config.formType && _this5.config.formType === 'list') {
              data.cid = _this5.rules.cid;
            }
            if (_this5.config.title == '编辑付款') {
              _this5.clientContractEdit(_this5.config.data.id, data);
            } else {
              _this5.clientContractSave(data);
            }
          } else if (_this5.rules.radio == 2 && _this5.config.type !== 3) {
            // 添加续费
            data = {
              cid: _this5.config.cid,
              eid: _this5.config.eid,
              types: 1,
              num: _this5.rules.amount,
              cate_id: _this5.rules.type,
              mark: _this5.rules.remarks,
              date: _this5.$moment(_this5.rules.dateTime).format('YYYY-MM-DD HH:mm:ss'),
              end_date: _this5.rules.endDate ? _this5.$moment(_this5.rules.endDate).format('YYYY-MM-DD ') : '',
              type_id: _this5.rules.type_id,
              attach_ids: _this5.rules.attach_ids,
              remind_id: _this5.remind_id
            };
            if (_this5.config.formType && _this5.config.formType === 'list') {
              data.cid = _this5.rules.cid;
            }
            if (_this5.config.title == '编辑付款') {
              _this5.clientContractEdit(_this5.config.data.id, data);
            } else {
              _this5.clientContractSave(data);
            }
          } else if (_this5.config.type === 5) {
            data = {
              eid: _this5.config.eid,
              types: 1,
              time: _this5.$moment(_this5.rules.dateTime).format('YYYY-MM-DD HH:mm:ss'),
              content: _this5.rules.content
            };
            _this5.config.edit === 1 ? _this5.clientFollowSave(data) : _this5.clientFollowEdit(_this5.config.data.id, data);
          } else if (_this5.config.type == 3 && _this5.rules.radio == 1) {
            // 付款提醒
            data = {
              cid: _this5.config.cid,
              eid: _this5.config.eid,
              num: _this5.rules.amount,
              types: 0,
              mark: _this5.rules.remarks,
              time: _this5.$moment(_this5.rules.endDate).format('YYYY-MM-DD HH:mm:ss')
            };
            if (_this5.config.title == '编辑付款提醒') {
              _this5.clientRemindEdit(_this5.config.data.id, data);
            } else {
              _this5.clientRemindSave(data);
            }
          } else if (_this5.config.type == 3 && _this5.rules.radio == 2) {
            // 续费提醒
            data = {
              cid: _this5.config.cid,
              eid: _this5.config.eid,
              num: _this5.rules.amount,
              types: 1,
              mark: _this5.rules.remarks,
              time: _this5.$moment(_this5.rules.endDate).format('YYYY-MM-DD HH:mm:ss'),
              cate_id: _this5.rules.type
            };
            if (_this5.config.title == '编辑付款提醒') {
              _this5.clientRemindEdit(_this5.config.data.id, data);
            } else {
              _this5.clientRemindSave(data);
            }
          }
        }
      });
    },
    reset: function reset() {
      this.rules.amount = undefined;
      this.rules.dateTime = '';
      this.rules.endDate = '';
      this.rules.remarks = '';
      this.rules.type = '';
      this.rules.radio = 1;
      this.rules.type_id = '';
      this.rules.day = undefined;
      // this.rules.period = 2;
      this.$refs.form.resetFields();
    },
    // 保存付款与续费
    clientContractSave: function clientContractSave(data) {
      var _this6 = this;
      this.loading = true;
      clientBillSaveApi(data).then(function (res) {
        _this6.loading = false;
        _this6.$emit('isOk');
        setTimeout(function () {
          _this6.handleClose();
          _this6.reset();
        }, 200);
      }).catch(function (error) {
        _this6.loading = false;
      });
    },
    // 修改付款与续费
    clientContractEdit: function clientContractEdit(id, data) {
      var _this7 = this;
      this.loading = true;
      clientBillEditApi(id, data).then(function (res) {
        _this7.loading = false;
        _this7.handleClose();
        _this7.reset();
        _this7.$emit('isOk');
      }).catch(function (error) {
        _this7.loading = false;
      });
    },
    // 跟进记录--客户提醒与跟进详情
    clientFollowSave: function clientFollowSave(data) {
      var _this8 = this;
      this.loading = true;
      clientFollowSaveApi(data).then(function (res) {
        _this8.loading = false;
        _this8.handleClose();
        _this8.reset();
        _this8.$emit('isOk');
      }).catch(function (error) {
        _this8.loading = false;
      });
    },
    // 跟进记录--修改客户提醒与跟进详情
    clientFollowEdit: function clientFollowEdit(id, data) {
      var _this9 = this;
      this.loading = true;
      clientFollowEditApi(id, data).then(function (res) {
        _this9.loading = false;
        _this9.handleClose();
        _this9.reset();
        _this9.$emit('isOk');
      }).catch(function (error) {
        _this9.loading = false;
      });
    },
    // 获取支付方式
    getPaymentMethod: function getPaymentMethod() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                status: 1
              };
              _context2.next = 3;
              return enterprisePayTypeApi(data);
            case 3:
              result = _context2.sent;
              _this10.paymentOptions = result.data.list;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 保存付款提醒
    clientRemindSave: function clientRemindSave(data) {
      var _this11 = this;
      this.loading = true;
      clientRemindSaveApi(data).then(function (res) {
        _this11.loading = false;
        _this11.$emit('isOk');
        setTimeout(function () {
          _this11.handleClose();
          _this11.reset();
        }, 200);
      }).catch(function (error) {
        _this11.loading = false;
      });
    },
    // 编辑付款提醒
    clientRemindEdit: function clientRemindEdit(id, data) {
      var _this12 = this;
      this.loading = true;
      clientRemindEditApi(id, data).then(function (res) {
        _this12.loading = false;
        _this12.handleClose();
        _this12.reset();
        _this12.$emit('isOk');
      }).catch(function (error) {
        _this12.loading = false;
      });
    }
  }
};